import React, {Component} from 'react'
import ListNextBoxes from "./ListNextBoxes"
import "../styles/index.scss"


class ListNextBoxesContainer extends Component {
    render() {
        return (
            <div className="ListNextBoxesContainer">
                <ListNextBoxes {...this.props}/>
            </div>
        )
    }
}

export default ListNextBoxesContainer
